import SparkleEyebrow from "@/components/motion/SparkleEyebrow";
import Reveal from "@/components/common/Reveal";

/**
 * Consistent section header — sparkle eyebrow + clean serif title.
 */
export const SectionIntro = ({
  eyebrow,
  title,
  subtitle,
  className = "",
  center = false,
}) => (
  <div className={`${center ? "text-center" : ""} ${className}`}>
    {eyebrow && (
      <Reveal y={6}>
        <SparkleEyebrow className={`wit-eyebrow text-raspberry mb-3 ${center ? "justify-center" : ""}`}>
          {eyebrow}
        </SparkleEyebrow>
      </Reveal>
    )}
    {title && (
      <Reveal delay={0.04}>
        <h2 className="wit-heading-section mb-2">{title}</h2>
      </Reveal>
    )}
    {subtitle && (
      <Reveal delay={0.08}>
        <p className={`wit-body max-w-lg ${center ? "mx-auto" : ""} ${title ? "mb-8" : "mb-6"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionIntro;
